<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-08 19:14:52
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 16:15:37
 * @Description: 选择订单明细
-->
<template>
  <div class="wrap column">
    <Search :searchConfig="tableConfig" @doSearch="doSearch" />
    <Table
      :tableEvent="tableEvent"
      ref="table"
      class="table-wrap flex-1"
      :tableConfig="tableConfig"
    >
      <template :slot="'orderReturnProportion'" slot-scope="scope">
        {{ mul(scope.row.orderReturnProportion || 0, 100) }}
      </template>
    </Table>
    <div class="btns">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button
        class="mgl"
        size="small"
        :disabled="multipleSelection.length > 0 ? false : true"
        type="primary"
        @click="confirm"
        >提交</el-button
      >
    </div>
  </div>
</template>

<script>
import Table from '@/components/table/index'
import Search from '@/components/search/index'
import { mul } from '@/utils/numberComputed'

export default {
  props: {
    invoiceType: {
      type: String,
      default: ''
    },
    orderCodeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    invoiceApplyNo: {
      type: String,
      default: ''
    }
  },
  components: {
    Table,
    Search
  },
  created () {
    this.doSearch({})
  },
  data () {
    return {
      tableData: [],
      multipleSelection: [], // 选中的值
      tableEvent: {
        'selection-change': (v) => {
          this.multipleSelection = v
        }
      },
      tableConfig: {
        searchUrl:
          '/front/oms/shopping/invoiceApply/orderItem/list', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        autoSearch: false, // 是否需要默认查询
        frontEndPaging: true, // 前端分页
        needPagination: true, // 是否需要分页
        fluidHeight: true, // 流体高度
        showOrdinal: true, // 是否显示序号,
        hideLabel: true, // 搜索隐藏label
        searchFlexStart: true, // 搜索按钮左对齐
        showCheckBox: true,
        checkBoxRowKey: 'checkedKey',
        checkSelectable: (row) => {
          const res = this.list.some((item) => {
            if (item.checkedKey === row.checkedKey) {
              return true
            }
            return false
          })
          return !res
        },
        params: [
          {
            prop: 'orderCode',
            label: '所属订单号',
            placeholder: '所属订单号',
            width: '160px'
          },
          {
            prop: 'goodsCode',
            label: '商品编号',
            placeholder: '商品编号'
          },
          {
            prop: 'goodsName',
            label: '商品名称',
            placeholder: '商品名称模糊'
          },
          {
            prop: 'goodsModel',
            label: '型号',
            hideInSearch: true
          },
          {
            prop: 'goodsNum',
            label: '商品数量',
            hideInSearch: true
          },
          {
            prop: 'hasInvoiceNum',
            label: '已开票数量',
            hideInSearch: true
          }
        ],
        extra: {
          orderCodeList: this.orderCodeList,
          invoiceType: this.invoiceType
        } // 额外的参数 搜索的条件
      }
    }
  },
  methods: {
    mul,
    doSearch (input) {
      const obj = {
        ...input,
        orderCodeList: this.orderCodeList,
        invoiceType: this.invoiceType,
        invoiceApplyNo: this.invoiceApplyNo || undefined
      }
      this.$http.post('/front/oms/shopping/invoiceApply/orderItem/list', obj).then(({ data: res }) => {
        console.log(res)
        if (res.code === 0) {
          const data = res.data
          this.tableData = data
          data.forEach((v) => {
            v.checkedKey = v.orderCode + '-' + v.goodsCode
          })
          console.log(this.$refs.table)
          this.$refs.table.setFrontPage(data)
        }
      })
    },
    // 关闭
    cancel () {
      this.$emit('cancel')
    },
    // 确认选择信息
    confirm () {
      this.$emit('confirm', [...this.multipleSelection])
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  height: 500px;
}
.btns {
  padding: 30px 0 0;
  text-align: center;
  .mgl {
    margin-left: 32px;
  }
}
</style>
